class aBtnToggleInput extends HTMLDivElement {
    constructor() {
        super();
        this.targets = [];

        // Setup internal triggers
        this.querySelectorAll('[data-trigger]').forEach((el) => {
            el.addEventListener(el.dataset.trigger, this.showDisplay.bind(this));
        });
    }

    connectedCallback() {
        this.targets = [...document.querySelectorAll(this.dataset.target)];

        // If there is a value in any of the fields, show them
        if (this.targets.every((el) => !el.querySelector('input, select, textarea')?.value)) {
            this.targets.forEach((target) => {
                target.classList.add('d-none');
            });
        } else {
            this.showDisplay();
        }
    }

    showDisplay() {
        this.targets.forEach((target) => {
            target.classList.remove('d-none');
        });

        // data-hide-after: Hide itself after toggled
        if ('hideAfter' in this.dataset) {
            this.classList.add('d-none');
        }
    }
}

customElements.define('a-btn-toggle-input', aBtnToggleInput, {
    extends: 'div',
});
